import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    Button,
    Typography,
    Container,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-scroll';
import { Menu as MenuIcon } from '@mui/icons-material';
import logo from '../../images/logo.jpeg';
import './_Header.scss';

const NAV_ITEMS = [
    { label: 'Home', to: 'home' },
    { label: 'About', to: 'about' },
    { label: 'Portfolio', to: 'portfolio' },
    { label: 'Projects', to: 'projects' },
    { label: 'Technology', to: 'technology' },
];

const Header = ({ handleContactOpen }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => setMobileOpen((prev) => !prev);

    return (
        <AppBar position="sticky" className="header">
            <Container>
                <Toolbar disableGutters>
                    <div className="logo">
                        <img src={logo} alt="Evolve Labs" className="logo-img" />
                    </div>

                    {isMobile ? (
                        <>
                            <IconButton
                                edge="end"
                                color="inherit"
                                aria-label="menu"
                                onClick={handleDrawerToggle}
                                sx={{ ml: 'auto' }}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Drawer
                                anchor="right"
                                open={mobileOpen}
                                onClose={handleDrawerToggle}
                                PaperProps={{
                                    sx: {
                                        backgroundColor: '#1A1B1D',
                                        width: 260,
                                        pt: 2,
                                    },
                                }}
                            >
                                <List>
                                    {NAV_ITEMS.map(({ label, to }) => (
                                        <ListItem key={to} disablePadding>
                                            <ListItemButton onClick={handleDrawerToggle}>
                                                <Link to={to} smooth duration={500}>
                                                    <ListItemText primary={label} />
                                                </Link>
                                            </ListItemButton>
                                        </ListItem>
                                    ))}
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            onClick={() => {
                                                handleDrawerToggle();
                                                handleContactOpen();
                                            }}
                                        >
                                            <ListItemText
                                                primary="Contact"
                                                primaryTypographyProps={{ color: '#EF002F', fontWeight: 600 }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                </List>
                            </Drawer>
                        </>
                    ) : (
                        <div className="nav-links">
                            {NAV_ITEMS.map(({ label, to }) => (
                                <Button key={to} color="inherit">
                                    <Link to={to} smooth duration={500}>
                                        {label}
                                    </Link>
                                </Button>
                            ))}
                            <Button onClick={handleContactOpen} className="button-red-outline">
                                Contact
                            </Button>
                        </div>
                    )}
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Header;
